var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4746 10.7179L8.55825 10.6469C8.81745 10.4576 9.17047 10.4552 9.43199 10.6399L9.5254 10.7179L16.4531 17.5186C15.9578 17.8239 15.3745 18 14.75 18H3.25C2.62551 18 2.04216 17.8239 1.54692 17.5186L8.4746 10.7179L8.55825 10.6469L8.4746 10.7179ZM14.75 0C16.5449 0 18 1.45507 18 3.25V14.75C18 15.3771 17.8224 15.9626 17.5148 16.4592L10.5762 9.64751L10.4477 9.53062C9.61495 8.82927 8.39415 8.82732 7.55923 9.52479L7.42379 9.64751L0.485196 16.4592C0.177581 15.9626 0 15.3771 0 14.75V3.25C0 1.45507 1.45507 0 3.25 0H14.75ZM12.7521 3C11.5083 3 10.5 4.00831 10.5 5.25212C10.5 6.49592 11.5083 7.50423 12.7521 7.50423C13.9959 7.50423 15.0042 6.49592 15.0042 5.25212C15.0042 4.00831 13.9959 3 12.7521 3ZM12.7521 4.5C13.1675 4.5 13.5042 4.83673 13.5042 5.25212C13.5042 5.6675 13.1675 6.00423 12.7521 6.00423C12.3367 6.00423 12 5.6675 12 5.25212C12 4.83673 12.3367 4.5 12.7521 4.5Z",
    fill: "#27A841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.4db43fac8a783651b6c37086557a9841.svg";
export { ForwardRef as ReactComponent };